import { OverviewHeader } from "../../../components/Header/OverviewHeader";
import type { CommonProcess } from "../../../types/common";
import { RefundRow } from "../rows/se/refundRow";
import { OverviewWrapper, ProcessWrapper } from "../styles";

const RefundOverview = (flow: CommonProcess | any) => {
  const { data } = flow?.caseData ?? {};
  const { country } = data || {};

  return (
    <OverviewWrapper>
      <OverviewHeader country={country} label="Refund sales finance" flow={flow} />
      <ProcessWrapper>
        <RefundRow data={data} />
      </ProcessWrapper>
    </OverviewWrapper >

  );
}

export default RefundOverview;
